import { useEffect } from "react"
import { useCookies } from "react-cookie"
import { useSetRecoilState } from "recoil"
import { isLoggedInState } from "../recoil/auth/atom"

const useAccessToken = () => {
  const [cookies] = useCookies()
  const setIsLoggedIn = useSetRecoilState(isLoggedInState)

  useEffect(() => {
    console.log(cookies.accessToken)
    if (cookies.accessToken) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  }, [cookies.accessToken, setIsLoggedIn])
}

export default useAccessToken
